module.exports = __webpack_public_path__ + "static/media/twitter_logo.46b8d1e0.svg";